import * as React from 'react';

import BodyWrapper, { LayoutTypes } from '../layout/BodyWrapper.jsx';
import Header from '../styleguide/Header.jsx';
import PageTitle from '../common/PageTitle.jsx';
import BackLink from '../common/BackLink.jsx';

import styles from './The420DealsPage.module.css';

const The420DealsPage = ({location}) => {

  // For return to brand page etc. on Category Filter back link
  const [backLink, setBackLink] = React.useState('/');
  React.useEffect(() => {
    const { returnToPath } = location?.state || {};
    if (returnToPath) {
      setBackLink(returnToPath);
    }
  }, [location])

  return (
    <BodyWrapper pageLayout={LayoutTypes.Narrow}>
      <PageTitle title="420 Deals" />
      <div className={styles.pageInner}>
        <Header isCentered withClass={styles.header}>
          { backLink &&
            <BackLink backToPath={backLink} inHeader />
          }
          Our 420 Deals
        </Header>

        <div className={styles.dealsWrap}>
          <div className={styles.dealsGrid}>
            <div className={styles.dealsItem}>
              <div className={styles.itemHdr}>April 13</div>
              <div className={styles.itemText}>
                <b>80% OFF</b> Select 3.5g Flower, 1g Infused Pre-Rolls & Gummies
              </div>
            </div>
            <div className={styles.dealsItem}>
              <div className={styles.itemHdr}>April 14</div>
              <div className={styles.itemText}>
                <b>$80 Ounces,</b> $3 1g Pre-Rolls, & $10 1g Vape Carts
              </div>
            </div>
            <div className={styles.dealsItem}>
              <div className={styles.itemHdr}>April 15</div>
              <div className={styles.itemText}>
                <b>50% OFF</b> 3.5g, 7g, 14g, 28g Flower, 1g Infused Pre-Rolls & Gummies
              </div>
            </div>
            <div className={styles.dealsItem}>
              <div className={styles.itemHdr}>April 16</div>
              <div className={styles.itemText}>
                <b>$10 3.5g Flower,</b> $10 Gummies, $10 1g Vapes
              </div>
            </div>
            <div className={styles.dealsItem}>
              <div className={styles.itemHdr}>April 17</div>
              <div className={styles.itemText}>
                <b>50% OFF</b> Select 3.5g, 7g & 14g Flower, 1g Infused Pre-Rolls & Concentrates
              </div>
            </div>
            <div className={styles.dealsItem}>
              <div className={styles.itemHdr}>April 18</div>
              <div className={styles.itemText}>
                <b>$75 28g Flower,</b> $2 1g Pre-Rolls & $8 Gummies
              </div>
            </div>
            <div className={styles.dealsItem}>
              <div className={styles.itemHdr}>April 19</div>
              <div className={styles.itemText}>
                <b>90% OFF</b> Select 3.5g Flower, Infused Pre-Rolls & 1g Vapes
              </div>
            </div>
            <div className={styles.dealsItem}>
              <div className={styles.itemHdr}>April 20</div>
              <div className={styles.itemText}>
                3.5g Flower for only <b>$4.20!</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BodyWrapper>
  );
};

export default The420DealsPage;
